module.exports = __webpack_public_path__ + "img/img 2.074ac1f8.png";